export async function createPaymentIntent({
  apiBaseUrl,
  appSlug,
  bearerToken,
  apiKey,
  amount,
  currency = 'usd',
  fetchImpl = fetch,
}) {
  if (!apiBaseUrl) {
    throw new Error('API base URL is required');
  }
  if (!appSlug) {
    throw new Error('App slug is required');
  }

  const headers = {
    'Content-Type': 'application/json',
  };
  if (bearerToken) {
    headers.Authorization = bearerToken;
  } else if (apiKey) {
    headers['X-API-Key'] = apiKey;
  }

  const response = await fetchImpl(
    `${apiBaseUrl.replace(/\/+$/, '')}/app/${appSlug}/create-payment-intent/`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify({
        ...(amount !== undefined ? { amount } : {}),
        currency,
      }),
    },
  );
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.error || `Payment intent failed with status ${response.status}`);
  }
  return data;
}
